/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ModalWithIframe from '../modal-with-iframe/modal-with-iframe';
import PlayIcon from '../svg/play-icon';
import { useImage } from '../../hooks/useImage';
import Row from '../row/row';
import Col from '../col/col';
import Link from '../link/link';
import './contact.scss';

const ContactSection = ({ content }) => {
  const [modalVisible, setModalVisible] = useState(false);

  const closeModal = () => {
    setModalVisible(false);
  };

  const openModal = () => {
    setModalVisible(true);
  };

  return (
    <section className='contact-section'>
      <div className='wrapper-fluid'>
        <Row wrap>
          <Col md={6} lg={4} lgOffset={1}>
            <header>
              <h2>{content.title}</h2>
            </header>
            <p dangerouslySetInnerHTML={{ __html: content.description }} />
            <Link to={content.cta_url}>{content.cta}</Link>
          </Col>
          <Col extra='video-preview' sm={8} md={5} lg={6} smOffset={2} mdOffset={1}>
            <figure>
              {useImage('contact-sherpa-keynote')}
              <figcaption>
                <button type='button' className='button button--link h4' onClick={() => openModal()}>
                  {content.video_caption}
                </button>
              </figcaption>
              <button type='button' className='button button--play' onClick={() => openModal()}>
                <PlayIcon />
              </button>
            </figure>
          </Col>
        </Row>
      </div>
      <ModalWithIframe
        videoUrl={content.video_url}
        visible={modalVisible}
        closeModal={closeModal}
        metatags={content.metatags}
      />
    </section>
  );
};

ContactSection.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    cta: PropTypes.string,
    cta_url: PropTypes.string,
    video_caption: PropTypes.string,
    video_url: PropTypes.string,
    metatags: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
    }),
  }),
};

export default ContactSection;
